export const keys = {
  YARD_CONFIG_SITE: "YARD_CONFIG_SITE",
  YARD_CONFIG_BUILDING_TYPE: "YARD_CONFIG_BUILDING_TYPE",
  YARD_CONFIG_YARD_TYPE: "YARD_CONFIG_YARD_TYPE",
  YARD_CONFIG_ASSET_TYPES: "YARD_CONFIG_ASSET_TYPES",
  YARD_CONFIG_UNNAMED_YARD: "YARD_CONFIG_UNNAMED_YARD",
  YARD_CONFIG_UNKNOWN_YARD: "YARD_CONFIG_UNKNOWN_YARD",
  YARD_CONFIG_NONE: "YARD_CONFIG_NONE",
  YARD_CONFIG_SHOW: "YARD_CONFIG_SHOW",
  YARD_CONFIG_CLOSE: "YARD_CONFIG_CLOSE",
  YARD_CONFIG_ERROR: "YARD_CONFIG_ERROR",
  CONTENT_MISMATCH_ALERT_DESCRIPTION: "CONTENT_MISMATCH_ALERT_DESCRIPTION",
  CONTENT_TAG_MISMATCH_ALERT_DESCRIPTION: "CONTENT_TAG_MISMATCH_ALERT_DESCRIPTION",
  CONTENT_TAG_MISMATCH_ALERT_BODY: "CONTENT_TAG_MISMATCH_ALERT_BODY",
  CONTENT_TAG_EXPECTED_CONSTRAINT: "CONTENT_TAG_EXPECTED_CONSTRAINT",
  CONTENT_TAG_COMPLETED: "CONTENT_TAG_COMPLETED",
  LOCATION_MISMATCH_ALERT_DESCRIPTION: "LOCATION_MISMATCH_ALERT_DESCRIPTION",
  VR_ALERT_DESCRIPTION: "VR_ALERT_DESCRIPTION",
  MISSING_CHECK_IN_ALERT_DESCRIPTION: "MISSING_CHECK_IN_ALERT_DESCRIPTION",
  UNVERIFIED_ASSET_ALERT_DESCRIPTION: "UNVERIFIED_ASSET_ALERT_DESCRIPTION",
  MISSING_CHECK_IN_ALERT_BODY: "MISSING_CHECK_IN_ALERT_BODY",
  MISSING_CHECK_IN_BADGE_LABEL: "MISSING_CHECK_IN_BADGE_LABEL",
  TRAILER_LOST_RELAY_CHECK_IN_BODY: "TRAILER_LOST_RELAY_CHECK_IN_BODY",
  TRAILER_LOST_PHYSICAL_ARRIVAL_BODY: "TRAILER_LOST_PHYSICAL_ARRIVAL_BODY",
  LOAD_DETAILS_TITLE: "LOAD_DETAILS_TITLE",
  LOAD_ID: "LOAD_ID",
  SHIPPER_ACCOUNT: "SHIPPER_ACCOUNT",
  REFERENCE_ID: "REFERENCE_ID",
  STOP: "STOP",
  SAT: "SAT",
  SDT: "SDT",
  ALERT_ARIA_LABEL: "ALERT_ARIA_LABEL",
  COPY_ALERT_ID_TOOLTIP: "COPY_ALERT_ID_TOOLTIP",
  TDR_SECTION_TITLE: "TDR_SECTION_TITLE",
  TDR_SECTION_STATUS: "TDR_SECTION_STATUS",
  TDR_STATUS_GREEN: "TDR_STATUS_GREEN",
  TDR_STATUS_RED: "TDR_STATUS_RED",
  TRAILER_DETAILS_TITLE: "TRAILER_DETAILS_TITLE",
  TRAILER_SCAC_CODE: "TRAILER_SCAC_CODE",
  TRAILER_OPERATOR_CODE: "TRAILER_OPERATOR_CODE",
  TRAILER_INTEGRITY: "TRAILER_INTEGRITY",
  TRAILER_STATE_PROVINCE: "TRAILER_STATE_PROVINCE",
  TRAILER_CONDITION: "TRAILER_CONDITION",
  TRAILER_FACILITY_LANE: "TRAILER_FACILITY_LANE",
  TRAILER_NUMBER: "TRAILER_NUMBER",
  TRAILER_NUMBER_REQUIRED: "TRAILER_NUMBER_REQUIRED",
  TRAILER_TYPE: "TRAILER_TYPE",
  TRAILER_CONTENTS_STATUS: "TRAILER_CONTENTS_STATUS",
  TRAILER_OWNER_CODE: "TRAILER_OWNER_CODE",
  TRAILER_LOAD_ID: "TRAILER_LOAD_ID",
  TRAILER_APPOINTMENT_TYPE: "TRAILER_APPOINTMENT_TYPE",
  INBOUND: "INBOUND",
  OUTBOUND: "OUTBOUND",
  TRAILER_STATUS_TITLE: "TRAILER_STATUS_TITLE",
  TRAILER_DWELL_TIME: "TRAILER_DWELL_TIME",
  TRAILER_LAST_MOVE: "TRAILER_LAST_MOVE",
  TIME_DAYS: "TIME_DAYS",
  TIME_HOURS: "TIME_HOURS",
  TIME_MINUTES: "TIME_MINUTES",
  TIME_AGO: "TIME_AGO",
  JUST_NOW: "JUST_NOW",
  SELECTED_CARD_ARIA: "SELECTED_CARD_ARIA",
  CARD_ARIA: "CARD_ARIA",
  TRAILER_FLAG: "TRAILER_FLAG",
  TRAILER_SEAL_NUMBER: "TRAILER_SEAL_NUMBER",
  EXPECTED_SEALS: "EXPECTED_SEALS",
  ACTUAL_SEALS: "ACTUAL_SEALS",
  EQUIPMENT_DETAILS: "EQUIPMENT_DETAILS",
  EQUIPMENT_STATUS_TITLE: "EQUIPMENT_STATUS_TITLE",
  TRACTOR_STATUS_TITLE: "TRACTOR_STATUS_TITLE",
  VEHICLE_DETAILS_TITLE: "VEHICLE_DETAILS_TITLE",
  VEHICLE_STATUS_TITLE: "VEHICLE_STATUS_TITLE",
  EQUIPMENT_TYPE: "EQUIPMENT_TYPE",
  EQUIPMENT_OWNER_CODE: "EQUIPMENT_OWNER_CODE",
  EQUIPMENT_NUMBER: "EQUIPMENT_NUMBER",
  EQUIPMENT_ID: "EQUIPMENT_ID",
  LICENSE_PLATE: "LICENSE_PLATE",
  VISIT_ID: "VISIT_ID",
  CHECK_IN_STATUS_TITLE: "CHECK_IN_STATUS_TITLE",
  EXPECTED_CHECK_IN_TIME: "EXPECTED_CHECK_IN_TIME",
  ZOOM_IN: "ZOOM_IN",
  ZOOM_OUT: "ZOOM_OUT",
  ZOOM_CONTROLS: "ZOOM_CONTROLS",
  SEARCH_FIELD_PLACEHOLDER: "SEARCH_DEFECT_PLACEHOLDER",
  SEARCH_AUDITS: "SEARCH_AUDITS",
  SEARCH_EQUIPMENT_PLACEHOLDER: "SEARCH_EQUIPMENT_PLACEHOLDER",
  SEARCH_FOR_EQUIPMENT: "SEARCH_FOR_EQUIPMENT",
  SEARCH_LOCATIONS_PLACEHOLDER: "SEARCH_LOCATIONS_PLACEHOLDER",
  TOGGLE_FILTERS: "TOGGLE_FILTERS",
  AUDIT_EMPTY: "AUDIT_EMPTY",
  AUDIT: "AUDIT",
  DEFECT: "DEFECT",
  ALERT_EMPTY: "ALERT_EMPTY",
  SEARCH_DEFECT_PLACEHOLDER: "SEARCH_DEFECT_PLACEHOLDER",
  FILTER: "FILTER",
  FILTER_ALERTS: "FILTER_ALERTS",
  FILTER_EQUIPMENT: "FILTER_EQUIPMENT",
  EQUIPMENT_TYPE_FILTER: "EQUIPMENT_TYPE_FILTER",
  VISIT_REASON_FILTER: "VISIT_REASON_FILTER",
  DWELL_TIME_FILTER: "DWELL_TIME_FILTER",
  LOCATION_TYPE_FILTER: "LOCATION_TYPE_FILTER",
  DWELL_TIME_UNDER_4H: "DWELL_TIME_UNDER_4H",
  DWELL_TIME_4H_TO_8H: "DWELL_TIME_4H_TO_8H",
  DWELL_TIME_8H_TO_12H: "DWELL_TIME_8H_TO_12H",
  DWELL_TIME_12H_TO_24H: "DWELL_TIME_12H_TO_24H",
  DWELL_TIME_OVER_24H: "DWELL_TIME_OVER_24H",
  TRAILER_DWELL_TITLE: "TRAILER_DWELL_TITLE",
  TRAILER_DWELL_TOTAL_TOOLTIP: "TRAILER_DWELL_TOTAL_TOOLTIP",
  EQUIPMENT_DWELL_TITLE: "EQUIPMENT_DWELL_TITLE",
  EQUIPMENT_DWELL_TOTAL_TOOLTIP: "EQUIPMENT_DWELL_TOTAL_TOOLTIP",
  EQUIPMENT_DWELL_0_TO_24_HOURS: "EQUIPMENT_DWELL_0_TO_24_HOURS",
  EQUIPMENT_DWELL_ARIA_TOTAL: "EQUIPMENT_DWELL_ARIA_TOTAL",
  EQUIPMENT_DWELL_FILTER_ARIA: "EQUIPMENT_DWELL_FILTER_ARIA",
  DETECTION_TYPE: "DETECTION_TYPE",
  ALERT_STATUS: "ALERT_STATUS",
  CANCEL: "CANCEL",
  SAVE: "SAVE",
  CONTENT_MISMATCH: "CONTENT_MISMATCH",
  CONTENT_TAG_MISMATCH: "CONTENT_TAG_MISMATCH",
  LOCATION_MISMATCH: "LOCATION_MISMATCH",
  LOCATION_MISMATCH_CAP: "LOCATION_MISMATCH_CAP",
  SPEEDING_CAP: "SPEEDING_CAP",
  SAFETY_BUBBLE_CAP: "SAFETY_BUBBLE_CAP",
  ANDONS_TITLE: "ANDONS_TITLE",
  ANDONS_IN_FLIGHT_TOOLTIP: "ANDONS_IN_FLIGHT_TOOLTIP",
  ANDONS_IN_QUEUE_TOOLTIP: "ANDONS_IN_QUEUE_TOOLTIP",
  ANDONS_ARIA_TOTAL: "ANDONS_ARIA_TOTAL",
  ANDONS_COL_CREATED: "ANDONS_COL_CREATED",
  ANDONS_CREATED_AGO: "ANDONS_CREATED_AGO",
  ANDONS_COL_DESCRIPTION: "ANDONS_COL_DESCRIPTION",
  ANDONS_COL_PRIORITY: "ANDONS_COL_PRIORITY",
  ANDONS_COL_LOCATION: "ANDONS_COL_LOCATION",
  ANDONS_COL_DRIVER_PHONE: "ANDONS_COL_DRIVER_PHONE",
  ANDONS_COL_STATUS: "ANDONS_COL_STATUS",
  ANDON_STATUS_PENDING_SCHEDULER: "ANDON_STATUS_PENDING_SCHEDULER",
  ANDON_STATUS_SCHEDULED: "ANDON_STATUS_SCHEDULED",
  ANDON_STATUS_EXECUTION_IN_PROGRESS: "ANDON_STATUS_EXECUTION_IN_PROGRESS",
  ANDON_STATUS_COMPLETED: "ANDON_STATUS_COMPLETED",
  ANDON_STATUS_CANCELLED: "ANDON_STATUS_CANCELLED",
  ANDON_STATUS_ERROR: "ANDON_STATUS_ERROR",
  ANDONS_EMPTY: "ANDONS_EMPTY",
  SPEEDING_ALERT: "SPEEDING_ALERT",
  PROXIMITY_ALERT: "PROXIMITY_ALERT",
  MISSING_CHECK_IN_MISMATCH: "MISSING_CHECK_IN_MISMATCH",
  RTT_ALERT: "RTT_ALERT",
  PENDING: "PENDING",
  JUST_DISMISSED: "JUST_DISMISSED",
  PENDING_SCHEDULER: "PENDING_SCHEDULER",
  SCHEDULED: "SCHEDULED",
  EXECUTION_IN_PROGRESS: "EXECUTION_IN_PROGRESS",
  COMPLETED: "COMPLETED",
  TRAILER_SEARCH_COMPLETED: "TRAILER_SEARCH_COMPLETED",
  TRAILER_SEARCH_IN_PROGRESS: "TRAILER_SEARCH_IN_PROGRESS",
  TRAILER_SEARCH_PARTIAL_COMPLETE: "TRAILER_SEARCH_PARTIAL_COMPLETE",
  TRAILER_SEARCH_DISMISSED: "TRAILER_SEARCH_DISMISSED",
  TRAILER_SEARCH_TAM_DISMISSED: "TRAILER_SEARCH_TAM_DISMISSED",
  TRAILER_SEARCH_TAM_COMPLETED: "TRAILER_SEARCH_TAM_COMPLETED",
  DISMISSED: "DISMISSED",
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  ERROR: "ERROR",
  ALERT_ACTIONS: "ALERT_ACTIONS",
  RESOLVE_ALERT: "RESOLVE_ALERT",
  DISMISS_ALERT: "DISMISS_ALERT",
  ACKNOWLEDGE_ALERT: "ACKNOWLEDGE_ALERT",
  VIEW_RTT: "VIEW_RTT",
  CONFIRM_YARD_DASHBOARD_CHECKIN_TITLE: "CONFIRM_YARD_DASHBOARD_CHECKIN_TITLE",
  CONFIRM_YARD_DASHBOARD_CHECKIN_MESSAGE: "CONFIRM_YARD_DASHBOARD_CHECKIN_MESSAGE",
  CONFIRM_TRAILER_STATUS_TITLE: "CONFIRM_TRAILER_STATUS_TITLE",
  CONFIRM_TRAILER_STATUS_MESSAGE: "CONFIRM_TRAILER_STATUS_MESSAGE",
  DISMISS_ALERT_TITLE: "DISMISS_ALERT_TITLE",
  DISMISS_ALERT_MESSAGE: "DISMISS_ALERT_MESSAGE",
  BOOK_VR_DRIVER_TITLE: "BOOK_VR_DRIVER_TITLE",
  BOOK_VR_DRIVER_MESSAGE: "BOOK_VR_DRIVER_MESSAGE",
  BOOK_DRIVER: "BOOK_DRIVER",
  ENTER_DRIVER_ALIAS: "ENTER_DRIVER_ALIAS",
  DRIVER_ALIAS_REQUIRED: "DRIVER_ALIAS_REQUIRED",
  FAILED_TO_BOOK_VR_DRIVER: "FAILED_TO_BOOK_VR_DRIVER",
  AN_ERROR_OCCURRED: "AN_ERROR_OCCURRED",
  NO_ALERT_ID_FOUND: "NO_ALERT_ID_FOUND",
  VIEW_TICKET: "VIEW_TICKET",
  VR_DRIVER_BOOKED_SUCCESSFULLY: "VR_DRIVER_BOOKED_SUCCESSFULLY",
  CONFIRM: "CONFIRM",
  FOUND: "FOUND",
  NOT_FOUND: "NOT_FOUND",
  EQUIPMENT_EMPTY: "EQUIPMENT_EMPTY",
  EQUIPMENT_LOAD_ERROR: "EQUIPMENT_LOAD_ERROR",
  EQUIPMENT: "EQUIPMENT",
  LOCATIONS: "LOCATIONS",
  LOADING: "LOADING",
  AUDIT_CREATE: "AUDIT_CREATE",
  AUDIT_REMOVE: "AUDIT_REMOVE",
  ACTION_DESCRIPTION: "ACTION_DESCRIPTION",
  UNVERIFIED_ASSET_ACTION_DESCRIPTION: "UNVERIFIED_ASSET_ACTION_DESCRIPTION",
  UNVERIFIED_ASSET_LOAD_ID_DESCRIPTION: "UNVERIFIED_ASSET_LOAD_ID_DESCRIPTION",
  TRAILER_SEARCH_NOT_FOUND_ACTION_DESCRIPTION: "TRAILER_SEARCH_NOT_FOUND_ACTION_DESCRIPTION",
  TRAILER_SEARCH_FOUND_ACTION_DESCRIPTION: "TRAILER_SEARCH_FOUND_ACTION_DESCRIPTION",
  ACTION_COMPLETE: "ACTION_COMPLETE",
  DETECTED: "DETECTED",
  YARD_HEALTH: "YARD_HEALTH",
  SITE: "SITE",
  SITE_PLACEHOLDER: "SITE_PLACEHOLDER",
  NO_RESULT: "NO_RESULT",
  CONSUMED_CAPACITY: "CONSUMED_CAPACITY",
  EFFECTIVE_CAPACITY: "EFFECTIVE_CAPACITY",
  MAP_SELECT: "MAP_SELECT",
  MAP_ERROR: "MAP_ERROR",
  LOCATION_LIST_SELECT: "LOCATION_LIST_SELECT",
  LOCATION_LIST_EMPTY: "LOCATION_LIST_EMPTY",
  LOCATION_LIST_ERROR: "LOCATION_LIST_ERROR",
  LOCATION_LIST_ARIA: "LOCATION_LIST_ARIA",
  UNKNOWN_LOCATION: "UNKNOWN_LOCATION",
  DISABLED: "DISABLED",
  AUDITS: "AUDITS",
  ALERTS: "ALERTS",
  TRAILER_ID: "TRAILER_ID",
  TRAILER_SEAL: "TRAILER_SEAL",
  LOCATION_DETAILS: "LOCATION_DETAILS",
  FILTER_PANEL: "FILTER_PANEL",
  FILTER_VALUE_PLACEHOLDER: "FILTER_VALUE_PLACEHOLDER",
  TABLIST_HEADING: "TABLIST_HEADING",
  NONE: "NONE",
  LOCATION_ALERT_TYPE: "LOCATION_ALERT_TYPE",
  CONTENT_ALERT_TYPE: "CONTENT_ALERT_TYPE",
  CONTENT_TAG_ALERT_TYPE: "CONTENT_TAG_ALERT_TYPE",
  VR_ALERT_TYPE: "VR_ALERT_TYPE",
  MISSING_CHECK_IN_ALERT_TYPE: "MISSING_CHECK_IN_ALERT_TYPE",
  SPEEDING_ALERT_ALERT_TYPE: "SPEEDING_ALERT_ALERT_TYPE",
  PROXIMITY_ALERT_ALERT_TYPE: "PROXIMITY_ALERT_ALERT_TYPE",
  SPEEDING_ALERT_TITLE: "SPEEDING_ALERT_TITLE",
  PROXIMITY_ALERT_TITLE: "PROXIMITY_ALERT_TITLE",
  SAFETY_EVENT_TITLE: "SAFETY_EVENT_TITLE",
  START_TIME: "START_TIME",
  END_TIME: "END_TIME",
  UNKNOWN_VEHICLE_ALERT_TYPE: "UNKNOWN_VEHICLE_ALERT_TYPE",
  NO_EQUIPMENT_AT_LOCATION: "NO_EQUIPMENT_AT_LOCATION",
  RESULTS_COUNT: "RESULTS_COUNT",
  RESULTS_COUNT_ARIA_LABEL: "RESULTS_COUNT_ARIA_LABEL",
  // Location Details Section keys
  LOCATION_DETAILS_TITLE: "LOCATION_DETAILS_TITLE",
  LOCATION_TYPE: "LOCATION_TYPE",
  LOCATION_CODE: "LOCATION_CODE",
  LOCATION_ZONES: "LOCATION_ZONES",
  LOCATION_CAPACITY: "LOCATION_CAPACITY",
  LOCATION_ID: "LOCATION_ID",
  SEAL: "SEAL",
  PARKING_SLIP: "PARKING_SLIP",
  DOCK_DOOR: "DOCK_DOOR",
  ENTRY_GATE: "ENTRY_GATE",
  OFF_SITE: "OFF_SITE",
  PENDING_ANDON_CREATION: "PENDING_ANDON_CREATION",
  ANDON_CREATED: "ANDON_CREATED",
  ANDON_ACKNOWLEDGED: "ANDON_ACKNOWLEDGED",
  PENDING_COMPLETION_CONFIRMATION: "PENDING_COMPLETION_CONFIRMATION",
  PARTIALLY_COMPLETED: "PARTIALLY_COMPLETED",
  PENDING_COMPLETION_ACTION: "PENDING_COMPLETION_ACTION",
  DISPLACED_ASSET: "DISPLACED_ASSET",
  UNVERIFIED_ASSET: "UNVERIFIED_ASSET",
  VALET_TASK_SUMMARY_TITLE: "VALET_TASK_SUMMARY_TITLE",
  JOB_OUTPUT_DATA_TITLE: "JOB_OUTPUT_DATA_TITLE",
  COMPLETED_AT: "COMPLETED_AT",
  TASK_ID: "TASK_ID",
  LOCATION: "LOCATION",
  UNKNOWN: "UNKNOWN",
  STATUS: "STATUS",
  LOAD: "LOAD",
  CONTENT_STATUS: "CONTENT_STATUS",
  SEAL_STATUS: "SEAL_STATUS",
  PRESENT: "PRESENT",
  NOT_PRESENT: "NOT_PRESENT",
  NOT_SET: "NOT_SET",
  EMPTY: "EMPTY",
  NOT_EMPTY: "NOT_EMPTY",
  HAS_SEAL: "HAS_SEAL",
  TAM_INVESTIGATION_REQUIRED: "TAM_INVESTIGATION_REQUIRED",
  ACTIVE_ALERTS_TITLE: "ACTIVE_ALERTS_TITLE",
  YARD_ACCURACY_TITLE: "YARD_ACCURACY_TITLE",
  DOOR_CAPACITY_TITLE: "DOOR_CAPACITY_TITLE",
  SLIP_CAPACITY_TITLE: "SLIP_CAPACITY_TITLE",
  TOTAL_CAPACITY_TITLE: "TOTAL_CAPACITY_TITLE",
  ERROR_LOADING_METRICS: "ERROR_LOADING_METRICS",
  TRAILER_SEARCH_REQUESTED: "TRAILER_SEARCH_REQUESTED",
  CONTENTS_STATUS_EMPTY: "CONTENTS_STATUS_EMPTY",
  CONTENTS_STATUS_LOADED: "CONTENTS_STATUS_LOADED",
  CONTENTS_STATUS_UNKNOWN: "CONTENTS_STATUS_UNKNOWN",
  CONTENTS_STATUS_NON_EMPTY: "CONTENTS_STATUS_NON_EMPTY",
  APPOINTMENT_TYPE_INBOUND: "APPOINTMENT_TYPE_INBOUND",
  APPOINTMENT_TYPE_OUTBOUND: "APPOINTMENT_TYPE_OUTBOUND",
  // Alt text for the yard-asset icon (vehicle silhouette by type + load state).
  YARD_ASSET_ICON_ALT: "YARD_ASSET_ICON_ALT",
  // Alt text for the location icon (dock / slip / gate).
  LOCATION_ICON_ALT: "LOCATION_ICON_ALT",
  // Rejection reasons (mirrors YMS GLOBAL:REJECTION_REASON:* set; the
  // reject-view renders the raw token via t() and falls back to the
  // raw string so unmapped reasons stay visible.)
  REJECTION_REASON_INCORRECT_SITE: "REJECTION_REASON_INCORRECT_SITE",
  REJECTION_REASON_YARD_IS_FULL: "REJECTION_REASON_YARD_IS_FULL",
  REJECTION_REASON_DRIVER_EARLY: "REJECTION_REASON_DRIVER_EARLY",
  REJECTION_REASON_LOAD_CANCELED: "REJECTION_REASON_LOAD_CANCELED",
  REJECTION_REASON_LOAD_TYPE_DISCREPANCY: "REJECTION_REASON_LOAD_TYPE_DISCREPANCY",
  REJECTION_REASON_NO_EMPTY_TRAILER_AVAILABLE: "REJECTION_REASON_NO_EMPTY_TRAILER_AVAILABLE",
  REJECTION_REASON_OTHER: "REJECTION_REASON_OTHER",
  REJECTION_REASON_PAPERWORK_NEEDED: "REJECTION_REASON_PAPERWORK_NEEDED",
  REJECTION_REASON_SEAL_ISSUE: "REJECTION_REASON_SEAL_ISSUE",
  REJECTION_REASON_WRONG_EQUIPMENT: "REJECTION_REASON_WRONG_EQUIPMENT",
  REJECTION_REASON_RELAY_APP_NOT_RUNNING: "REJECTION_REASON_RELAY_APP_NOT_RUNNING",
  REJECTION_REASON_BANNED_EQUIPMENT: "REJECTION_REASON_BANNED_EQUIPMENT",
  REJECTION_REASON_SELFIE_FAIL: "REJECTION_REASON_SELFIE_FAIL",
  REJECTION_REASON_CARRIER_CARB_NON_COMPLIANT: "REJECTION_REASON_CARRIER_CARB_NON_COMPLIANT",
  REJECTION_REASON_SCAC_MISMATCH: "REJECTION_REASON_SCAC_MISMATCH",
  REJECTION_REASON_ASSET_NOT_FOUND: "REJECTION_REASON_ASSET_NOT_FOUND",
  REJECTION_REASON_ASSET_NOT_VERIFIED: "REJECTION_REASON_ASSET_NOT_VERIFIED",
  REJECTION_REASON_ASSET_CARRIER_RELATIONSHIP_NOT_FOUND:
    "REJECTION_REASON_ASSET_CARRIER_RELATIONSHIP_NOT_FOUND",
  REJECTION_REASON_ASSET_CARRIER_RELATIONSHIP_NOT_VERIFIED:
    "REJECTION_REASON_ASSET_CARRIER_RELATIONSHIP_NOT_VERIFIED",
  REJECTION_REASON_TOO_EARLY_ARRIVAL_FOR_CHECKIN: "REJECTION_REASON_TOO_EARLY_ARRIVAL_FOR_CHECKIN",
  REJECTION_REASON_LOAD_CANCELED_FOR_CHECKIN: "REJECTION_REASON_LOAD_CANCELED_FOR_CHECKIN",
  REJECTION_REASON_OUTBOUND_LOAD_ALREADY_COMPLETED:
    "REJECTION_REASON_OUTBOUND_LOAD_ALREADY_COMPLETED",
  REJECTION_REASON_NON_COMPLIANT_LICENSE_PLATE: "REJECTION_REASON_NON_COMPLIANT_LICENSE_PLATE",
  LOCATION_STATUS: "LOCATION_STATUS",
  OCCUPIED: "OCCUPIED",
  INPUT_PLACEHOLDER_OPTIONAL: "INPUT_PLACEHOLDER_OPTIONAL",
  VIEW_IN: "VIEW_IN",
  // Save feedback keys
  SAVE_SUCCESS_TITLE: "SAVE_SUCCESS_TITLE",
  SAVE_SUCCESS_MESSAGE: "SAVE_SUCCESS_MESSAGE",
  SAVE_ERROR_TITLE: "SAVE_ERROR_TITLE",
  SAVE_ERROR_MESSAGE: "SAVE_ERROR_MESSAGE",
  CONTENT_TAG_SAVE_ERROR_MESSAGE: "CONTENT_TAG_SAVE_ERROR_MESSAGE",
  // Action panel keys
  REQUEST_MOVE: "REQUEST_MOVE",
  VIEW_HISTORY: "VIEW_HISTORY",
  ACTIONS_BUTTON: "ACTIONS_BUTTON",
  ACTION_PANEL_TITLE: "ACTION_PANEL_TITLE",
  ACTION_PANEL_PLACEHOLDER: "ACTION_PANEL_PLACEHOLDER",
  ACTION_PANEL_ARIA_LABEL: "ACTION_PANEL_ARIA_LABEL",
  // Request Move form keys
  FROM_LOCATION: "FROM_LOCATION",
  TO_LOCATION: "TO_LOCATION",
  FORCE_MOVE: "FORCE_MOVE",
  FORCE_MOVE_DESCRIPTION: "FORCE_MOVE_DESCRIPTION",
  OWNER_CODE: "OWNER_CODE",
  VEHICLE_NUMBER: "VEHICLE_NUMBER",
  SUBMIT_MOVE: "SUBMIT_MOVE",
  MOVE_REQUEST_SUCCESS: "MOVE_REQUEST_SUCCESS",
  MOVE_COMPLETED_SUCCESS: "MOVE_COMPLETED_SUCCESS",
  MOVE_REQUEST_ERROR: "MOVE_REQUEST_ERROR",
  VISIT_NOT_FOUND: "VISIT_NOT_FOUND",
  NO_EQUIPMENT_FOUND: "NO_EQUIPMENT_FOUND",
  SELECT_LOCATION: "SELECT_LOCATION",
  LOADING_LOCATIONS: "LOADING_LOCATIONS",
  HOSTLER_MOVE_MESSAGE: "HOSTLER_MOVE_MESSAGE",
  MOVE_API_FALLBACK_ERROR: "MOVE_API_FALLBACK_ERROR",
  // Edit panel keys
  EDIT: "EDIT",
  EDIT_SECTION_ARIA_LABEL: "EDIT_SECTION_ARIA_LABEL",
  SECTION_INFO_ARIA_LABEL: "SECTION_INFO_ARIA_LABEL",
  EXPAND_SECTION_ARIA_LABEL: "EXPAND_SECTION_ARIA_LABEL",
  LINKED_VEHICLES_TITLE: "LINKED_VEHICLES_TITLE",
  EDIT_EQUIPMENT_DETAILS_ARIA_LABEL: "EDIT_EQUIPMENT_DETAILS_ARIA_LABEL",
  LOADING_CODES: "LOADING_CODES",
  SEARCH_CODES_PLACEHOLDER: "SEARCH_CODES_PLACEHOLDER",
  AUTOSUGGEST_PLACEHOLDER: "AUTOSUGGEST_PLACEHOLDER",
  AUTOSUGGEST_LOADING: "AUTOSUGGEST_LOADING",
  AUTOSUGGEST_NO_MATCH: "AUTOSUGGEST_NO_MATCH",
  // Completed status metadata
  YMS_CHECK_IN_TIME: "YMS_CHECK_IN_TIME",
  AUTO_COMPLETED_TIMESTAMP_LINE: "AUTO_COMPLETED_TIMESTAMP_LINE",
  // Trailer search completed — per-resolution titles (Yard-5719)
  TRAILER_SEARCH_COMPLETED_SOURCE_SYSTEM: "TRAILER_SEARCH_COMPLETED_SOURCE_SYSTEM",
  TRAILER_SEARCH_COMPLETED_JOB_EXPIRED: "TRAILER_SEARCH_COMPLETED_JOB_EXPIRED",
  NOTES_TITLE: "NOTES_TITLE",
  NOTES_PLACEHOLDER: "NOTES_PLACEHOLDER",
  NOTES_EMPTY: "NOTES_EMPTY",
  OPERATIONAL_CODE_RED: "OPERATIONAL_CODE_RED",
  OPERATIONAL_CODE_YELLOW: "OPERATIONAL_CODE_YELLOW",
  OPERATIONAL_CODE_STORAGE: "OPERATIONAL_CODE_STORAGE",
  OPERATIONAL_CODES_LABEL: "OPERATIONAL_CODES_LABEL",
  // Filter category headers
  FILTER_CATEGORY_LOCATION: "FILTER_CATEGORY_LOCATION",
  FILTER_CATEGORY_EQUIPMENT: "FILTER_CATEGORY_EQUIPMENT",
  FILTER_CATEGORY_LOAD: "FILTER_CATEGORY_LOAD",
  // New filter labels
  LOCATION_CATEGORY_FILTER: "LOCATION_CATEGORY_FILTER",
  EQUIPMENT_STATUS_FILTER: "EQUIPMENT_STATUS_FILTER",
  LOCATION_STATUS_FILTER: "LOCATION_STATUS_FILTER",
  // New filter option values
  NON_INVENTORY: "NON_INVENTORY",
  LIVE: "LIVE",
  FULL: "FULL",
  IN_PROGRESS: "IN_PROGRESS",
  PAUSED: "PAUSED",
  AVAILABLE: "AVAILABLE",
  // Realignment move keys
  REALIGN: "REALIGN",
  REALIGN_SUCCESS: "REALIGN_SUCCESS",
  REALIGN_ERROR: "REALIGN_ERROR",
  REALIGN_BLOCKED_BY_CONDITION: "REALIGN_BLOCKED_BY_CONDITION",
  // Move-to-Exit-Gate keys
  REQUEST_MOVE_TO_EXIT_GATE: "REQUEST_MOVE_TO_EXIT_GATE",
  MOVE_TO_EXIT_GATE_SUCCESS: "MOVE_TO_EXIT_GATE_SUCCESS",
  MOVE_TO_EXIT_GATE_ERROR: "MOVE_TO_EXIT_GATE_ERROR",
  MOVE_TO_EXIT_GATE_CONFIRM: "MOVE_TO_EXIT_GATE_CONFIRM",
  ADD_VEHICLE: "ADD_VEHICLE",
  ADD_VEHICLE_PLACEHOLDER: "ADD_VEHICLE_PLACEHOLDER",
  VEHICLE_ALREADY_ADDED: "VEHICLE_ALREADY_ADDED",
  REMOVE_VEHICLE_ARIA_LABEL: "REMOVE_VEHICLE_ARIA_LABEL",
  CARRIER: "CARRIER",
  CARRIER_SCAC: "CARRIER_SCAC",
  VEHICLE_ID: "VEHICLE_ID",
  NO_VEHICLES_SELECTED: "NO_VEHICLES_SELECTED",
  EQUIPMENT_IDENTIFIER_MISSING: "EQUIPMENT_IDENTIFIER_MISSING",
  // Operational Activity Row keys
  OPERATIONAL_ACTIVITY_ROW_TITLE: "OPERATIONAL_ACTIVITY_ROW_TITLE",
  OPERATIONAL_ACTIVITY_REJECT_CI: "OPERATIONAL_ACTIVITY_REJECT_CI",
  OPERATIONAL_ACTIVITY_REJECT_CO: "OPERATIONAL_ACTIVITY_REJECT_CO",
  OPERATIONAL_ACTIVITY_CHECKING_OUT: "OPERATIONAL_ACTIVITY_CHECKING_OUT",
  OPERATIONAL_ACTIVITY_HOSTLER_MOVES: "OPERATIONAL_ACTIVITY_HOSTLER_MOVES",
  OPERATIONAL_ACTIVITY_DISPLACED: "OPERATIONAL_ACTIVITY_DISPLACED",
  // Operational Activity Modal title keys
  OPERATIONAL_ACTIVITY_MODAL_TITLE_REJECT_CI: "OPERATIONAL_ACTIVITY_MODAL_TITLE_REJECT_CI",
  OPERATIONAL_ACTIVITY_MODAL_TITLE_REJECT_CO: "OPERATIONAL_ACTIVITY_MODAL_TITLE_REJECT_CO",
  OPERATIONAL_ACTIVITY_MODAL_TITLE_CHECKING_OUT: "OPERATIONAL_ACTIVITY_MODAL_TITLE_CHECKING_OUT",
  OPERATIONAL_ACTIVITY_MODAL_TITLE_HOSTLER_MOVES: "OPERATIONAL_ACTIVITY_MODAL_TITLE_HOSTLER_MOVES",
  OPERATIONAL_ACTIVITY_MODAL_TITLE_DISPLACED: "OPERATIONAL_ACTIVITY_MODAL_TITLE_DISPLACED",
  // Operational Activity Modal warn/error filtered title keys (parametric by label)
  OPERATIONAL_ACTIVITY_MODAL_TITLE_WARN: "OPERATIONAL_ACTIVITY_MODAL_TITLE_WARN",
  OPERATIONAL_ACTIVITY_MODAL_TITLE_ERROR: "OPERATIONAL_ACTIVITY_MODAL_TITLE_ERROR",
  // Operational Activity other keys
  OPERATIONAL_ACTIVITY_MODAL_CLOSE: "OPERATIONAL_ACTIVITY_MODAL_CLOSE",
  OPERATIONAL_ACTIVITY_MODAL_EMPTY: "OPERATIONAL_ACTIVITY_MODAL_EMPTY",
  OPERATIONAL_ACTIVITY_ERROR_ALERT: "OPERATIONAL_ACTIVITY_ERROR_ALERT",
  // Operational Activity aria-label keys
  OPERATIONAL_ACTIVITY_ARIA_TOTAL: "OPERATIONAL_ACTIVITY_ARIA_TOTAL",
  OPERATIONAL_ACTIVITY_ARIA_WARN: "OPERATIONAL_ACTIVITY_ARIA_WARN",
  OPERATIONAL_ACTIVITY_ARIA_ERROR: "OPERATIONAL_ACTIVITY_ARIA_ERROR",
  OPERATIONAL_ACTIVITY_DURATION_MIN: "OPERATIONAL_ACTIVITY_DURATION_MIN",
  OPERATIONAL_ACTIVITY_DURATION_HR: "OPERATIONAL_ACTIVITY_DURATION_HR",
  // Reject CI / Reject CO view-specific keys
  REJECTION_REASON: "REJECTION_REASON",
  TIME_AT_LOCATION: "TIME_AT_LOCATION",
  REJECT_VIEW_ACTION_MOVE: "REJECT_VIEW_ACTION_MOVE",
  REJECT_VIEW_ACTION_HISTORY: "REJECT_VIEW_ACTION_HISTORY",
  REJECT_VIEW_ACTION_REMOVE: "REJECT_VIEW_ACTION_REMOVE",
  REJECT_VIEW_ACTION_EDIT: "REJECT_VIEW_ACTION_EDIT",
  EDIT_EQUIPMENT_MODAL_TITLE: "EDIT_EQUIPMENT_MODAL_TITLE",
  EQUIPMENT_ID_REQUIRED: "EQUIPMENT_ID_REQUIRED",
  CARRIER_REQUIRED: "CARRIER_REQUIRED",
  VEHICLE_TYPE_REQUIRED: "VEHICLE_TYPE_REQUIRED",
  LICENSE_PLATE_REQUIRED: "LICENSE_PLATE_REQUIRED",
  // Hostler Moves view-specific keys
  HOSTLER_MOVES_COL_SUB_CARRIER: "HOSTLER_MOVES_COL_SUB_CARRIER",
  HOSTLER_MOVES_COL_ID: "HOSTLER_MOVES_COL_ID",
  HOSTLER_MOVES_COL_IDENTIFIER: "HOSTLER_MOVES_COL_IDENTIFIER",
  HOSTLER_MOVES_COL_PICKED_UP_BY_AYH: "HOSTLER_MOVES_COL_PICKED_UP_BY_AYH",
  HOSTLER_MOVES_COL_FROM_TO: "HOSTLER_MOVES_COL_FROM_TO",
  HOSTLER_MOVES_COL_LINK: "HOSTLER_MOVES_COL_LINK",
  HOSTLER_MOVES_COL_TIMER: "HOSTLER_MOVES_COL_TIMER",
  HOSTLER_MOVES_COL_REQUESTED_BY: "HOSTLER_MOVES_COL_REQUESTED_BY",
  HOSTLER_MOVES_ACTION_CANCEL: "HOSTLER_MOVES_ACTION_CANCEL",
  HOSTLER_MOVES_ACTION_COMPLETE: "HOSTLER_MOVES_ACTION_COMPLETE",
  HOSTLER_MOVES_CANCEL_TITLE: "HOSTLER_MOVES_CANCEL_TITLE",
  HOSTLER_MOVES_CANCEL_MESSAGE_EXECUTOR: "HOSTLER_MOVES_CANCEL_MESSAGE_EXECUTOR",
  HOSTLER_MOVES_CANCEL_MESSAGE_DEPENDENT: "HOSTLER_MOVES_CANCEL_MESSAGE_DEPENDENT",
  HOSTLER_MOVES_CANCEL_DOCKFLOW_TITLE: "HOSTLER_MOVES_CANCEL_DOCKFLOW_TITLE",
  HOSTLER_MOVES_CANCEL_DOCKFLOW_MESSAGE: "HOSTLER_MOVES_CANCEL_DOCKFLOW_MESSAGE",
  HOSTLER_MOVES_CANCEL_REASON_LABEL: "HOSTLER_MOVES_CANCEL_REASON_LABEL",
  HOSTLER_MOVES_CANCEL_REASON_PLACEHOLDER: "HOSTLER_MOVES_CANCEL_REASON_PLACEHOLDER",
  HOSTLER_MOVES_CANCEL_REASON_DOOR_INCOMPATIBLE: "HOSTLER_MOVES_CANCEL_REASON_DOOR_INCOMPATIBLE",
  HOSTLER_MOVES_CANCEL_REASON_DOOR_UNAVAILABLE: "HOSTLER_MOVES_CANCEL_REASON_DOOR_UNAVAILABLE",
  HOSTLER_MOVES_CANCEL_REASON_EQUIPMENT_DAMAGED: "HOSTLER_MOVES_CANCEL_REASON_EQUIPMENT_DAMAGED",
  HOSTLER_MOVES_CANCEL_REASON_OTHER: "HOSTLER_MOVES_CANCEL_REASON_OTHER",
  HOSTLER_MOVES_CANCEL_CONFIRM: "HOSTLER_MOVES_CANCEL_CONFIRM",
  HOSTLER_MOVES_CANCEL_DISMISS: "HOSTLER_MOVES_CANCEL_DISMISS",
  HOSTLER_MOVES_YES: "HOSTLER_MOVES_YES",
  HOSTLER_MOVES_MANUALLY_PRIORITIZED: "HOSTLER_MOVES_MANUALLY_PRIORITIZED",
  HOSTLER_MOVES_QUEUE_NOT_FIFO_HELP: "HOSTLER_MOVES_QUEUE_NOT_FIFO_HELP",
  HOSTLER_MOVES_NO: "HOSTLER_MOVES_NO",
  HOSTLER_MOVES_STATUS_SCHEDULED: "HOSTLER_MOVES_STATUS_SCHEDULED",
  HOSTLER_MOVES_STATUS_IN_PROGRESS: "HOSTLER_MOVES_STATUS_IN_PROGRESS",
  HOSTLER_MOVES_REORDER_VIOLATION_BLOCKED: "HOSTLER_MOVES_REORDER_VIOLATION_BLOCKED",
  HOSTLER_MOVES_REORDER_VIOLATION_BLOCKING: "HOSTLER_MOVES_REORDER_VIOLATION_BLOCKING",
  HOSTLER_MOVES_REORDER_ROW_LABEL: "HOSTLER_MOVES_REORDER_ROW_LABEL",
  HOSTLER_MOVES_DEP_DEPENDS_ON: "HOSTLER_MOVES_DEP_DEPENDS_ON",
  HOSTLER_MOVES_DEP_BLOCKS: "HOSTLER_MOVES_DEP_BLOCKS",
  LICENSE_PLATE_INVALID: "LICENSE_PLATE_INVALID",
  ERROR_DOCK_SYSTEM_LOCKED: "ERROR_DOCK_SYSTEM_LOCKED",
  IDENTIFIER_PLACEHOLDER: "IDENTIFIER_PLACEHOLDER",
  VALIDATION_ERROR_FIELD: "VALIDATION_ERROR_FIELD",
  // Visit List View (Checking Out / Displaced shared columns)
  VIRTUAL_MOVE_MESSAGE: "VIRTUAL_MOVE_MESSAGE",
  VISIT_REASON: "VISIT_REASON",
  // Token set mirrors YMS `loadDesignation`.
  VISIT_REASON_INBOUND: "VISIT_REASON_INBOUND",
  VISIT_REASON_OUTBOUND: "VISIT_REASON_OUTBOUND",
  VISIT_REASON_NON_INVENTORY: "VISIT_REASON_NON_INVENTORY",
  VISIT_REASON_PASS_THROUGH: "VISIT_REASON_PASS_THROUGH",
  VISIT_REASON_DSP: "VISIT_REASON_DSP",
  VISIT_REASON_OTHER: "VISIT_REASON_OTHER",
  // Id column empty-state for types whose YER `hasEquipmentNumber` is MUST_NOT.
  VEHICLE_ID_NOT_REQUIRED: "VEHICLE_ID_NOT_REQUIRED",
  // Field empty-states for types whose YER metadata is MUST_NOT (hide + label).
  LICENSE_PLATE_NOT_REQUIRED: "LICENSE_PLATE_NOT_REQUIRED",
  OWNER_CODE_NOT_REQUIRED: "OWNER_CODE_NOT_REQUIRED",
  // SiteHeader / Yard Actions dropdown
  NEED_HELP: "NEED_HELP",
  YARD_ACTIONS: "YARD_ACTIONS",
  CSV_EXPORT: "CSV_EXPORT",
  CSV_EXPORTING: "CSV_EXPORTING",
  CSV_EXPORT_SUCCESS: "CSV_EXPORT_SUCCESS",
  CSV_EXPORT_FAILED: "CSV_EXPORT_FAILED",
  // Yard action: Remove Vehicle
  REMOVE_VEHICLE_TAB: "REMOVE_VEHICLE_TAB",
  SELECT_VEHICLE: "SELECT_VEHICLE",
  SELECT_VEHICLE_PLACEHOLDER: "SELECT_VEHICLE_PLACEHOLDER",
  LOADING_VEHICLES: "LOADING_VEHICLES",
  VEHICLE_SELECT_SHOWING_COUNT: "VEHICLE_SELECT_SHOWING_COUNT",
  REMOVE_VEHICLE_SUCCESS: "REMOVE_VEHICLE_SUCCESS",
  REMOVE_VEHICLE_ERROR: "REMOVE_VEHICLE_ERROR",
  REMOVE_VEHICLE_ERROR_WITH_REASON: "REMOVE_VEHICLE_ERROR_WITH_REASON",
  // Yard action: Audit Move
  AUDIT_MOVE: "AUDIT_MOVE",
  AUDIT_MOVE_SUCCESS: "AUDIT_MOVE_SUCCESS",
  AUDIT_MOVE_ERROR: "AUDIT_MOVE_ERROR",
  AUDIT_MOVE_ERROR_WITH_REASON: "AUDIT_MOVE_ERROR_WITH_REASON",
  // Yard action: Emergency Checkout
  EMERGENCY_CHECKOUT: "EMERGENCY_CHECKOUT",
  EMERGENCY_CHECKOUT_WARNING: "EMERGENCY_CHECKOUT_WARNING",
  EMERGENCY_CHECKOUT_ACKNOWLEDGE: "EMERGENCY_CHECKOUT_ACKNOWLEDGE",
  RED_TAG_ACKNOWLEDGE: "RED_TAG_ACKNOWLEDGE",
  EMERGENCY_CHECKOUT_SUCCESS: "EMERGENCY_CHECKOUT_SUCCESS",
  EMERGENCY_CHECKOUT_ERROR: "EMERGENCY_CHECKOUT_ERROR",
  EMERGENCY_CHECKOUT_ERROR_WITH_REASON: "EMERGENCY_CHECKOUT_ERROR_WITH_REASON",
  // Yard action: Emergency Status Override
  EMERGENCY_STATUS_OVERRIDE: "EMERGENCY_STATUS_OVERRIDE",
  TDR_STATE: "TDR_STATE",
  TDR_STATE_PLACEHOLDER: "TDR_STATE_PLACEHOLDER",
  TDR_IN: "TDR_IN",
  TDR_OUT: "TDR_OUT",
  TDR_NOT_AT_DOCK_DOOR: "TDR_NOT_AT_DOCK_DOOR",
  STATUS_OVERRIDE_WARNING: "STATUS_OVERRIDE_WARNING",
  STATUS_OVERRIDE_ACKNOWLEDGE: "STATUS_OVERRIDE_ACKNOWLEDGE",
  STATUS_OVERRIDE_RED_TAG_ACKNOWLEDGE: "STATUS_OVERRIDE_RED_TAG_ACKNOWLEDGE",
  STATUS_OVERRIDE_SUCCESS: "STATUS_OVERRIDE_SUCCESS",
  STATUS_OVERRIDE_ERROR: "STATUS_OVERRIDE_ERROR",
  STATUS_OVERRIDE_ERROR_WITH_REASON: "STATUS_OVERRIDE_ERROR_WITH_REASON",
  // Add Vehicle modal
  ADD_VEHICLE_TAB: "ADD_VEHICLE_TAB",
  CARRIER_PLACEHOLDER: "CARRIER_PLACEHOLDER",
  VEHICLE_TYPE: "VEHICLE_TYPE",
  VEHICLE_TYPE_PLACEHOLDER: "VEHICLE_TYPE_PLACEHOLDER",
  VEHICLE_ID_PLACEHOLDER: "VEHICLE_ID_PLACEHOLDER",
  LICENSE_PLATE_PLACEHOLDER: "LICENSE_PLATE_PLACEHOLDER",
  LICENSE_PLATE_REGION: "LICENSE_PLATE_REGION",
  LICENSE_PLATE_REGION_PLACEHOLDER: "LICENSE_PLATE_REGION_PLACEHOLDER",
  COUNTRY_CODE: "COUNTRY_CODE",
  COUNTRY_CODE_PLACEHOLDER: "COUNTRY_CODE_PLACEHOLDER",
  SUBNATIONAL_ENTITY: "SUBNATIONAL_ENTITY",
  SUBNATIONAL_ENTITY_PLACEHOLDER: "SUBNATIONAL_ENTITY_PLACEHOLDER",
  OPTIONAL: "OPTIONAL",
  TO_LOCATION_PLACEHOLDER: "TO_LOCATION_PLACEHOLDER",
  ADD_VEHICLE_SUCCESS: "ADD_VEHICLE_SUCCESS",
  ADD_VEHICLE_ERROR: "ADD_VEHICLE_ERROR",
  PARTIAL_MATCH_WARNING: "PARTIAL_MATCH_WARNING",
  NEXT: "NEXT",
  BACK: "BACK",
  // Blue Flag indicator
  BLUE_FLAGGED: "BLUE_FLAGGED",
  BLUE_FLAG_RISKS: "BLUE_FLAG_RISKS",
  // Equipment overflow tooltip (LocationListView)
  ADDITIONAL_VEHICLES: "ADDITIONAL_VEHICLES",
  ADDITIONAL_VEHICLES_ARIA: "ADDITIONAL_VEHICLES_ARIA",
};
